export enum SubmitIcons
{
    close           = 'close',
    delete          = 'delete',
    save            = 'save',
    navigate_before = 'navigate_before',
    navigate_next   = 'navigate_next',
}